export const codeOptions = [
  {
    value: "CODE39",
    label: "Code 39",
  },
  {
    value: "CODE128",
    label: "Code 128",
  },
  {
    value: "EAN13",
    label: "EAN-13",
  },
  {
    value: "QRCODE",
    label: "QR Code",
  },
];
